import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { find, propEq, filter } from 'ramda';

import styles from './styles.m.scss';
import { routes } from '../../routes';
import magic from '../../util/magic';

import Avatar from '../Avatar';
import Progress from '../Progress';
import { isNilOrEmpty } from '../../util/redux';
import { calculatePercent } from '../../util/helpers';

const propTypes = {
  collapsed: PropTypes.bool,
  user: PropTypes.object,
};

class Sidebar extends Component {
  renderBasicInfo = () => {
    const { user } = this.props;
    const primaryAddress = find(propEq('id', user.primaryAddressId), user.addresses);
    return (
      <Fragment>
        <Avatar src={user.avatar} className="mb-4" />
        <h3 className="my-0">
          {user.firstName} {user.lastName}
        </h3>
        {primaryAddress && (
          <p>
            {primaryAddress.city}, {primaryAddress.state} {primaryAddress.country}
          </p>
        )}
      </Fragment>
    );
  };

  renderProgressSection = () => {
    const { user } = this.props;
    let filledOutFields = 0;
    const fieldsToCheck = magic.profileFields;
    fieldsToCheck.forEach((field) => (filledOutFields += !isNilOrEmpty(user[field])));
    if (!isNilOrEmpty(user.areasOfWorkOther) || !isNilOrEmpty(user.workAreas)) filledOutFields++;
    const percentageFilled = calculatePercent(filledOutFields, fieldsToCheck.length + 1);

    return (
      <Fragment>
        <hr />
        <span>
          Profile <span className="yellow-heading font-weight-bold">{percentageFilled}%</span> Complete
        </span>
        <div className="w-100 p-3">
          <Progress percent={percentageFilled} small />
        </div>
        <Link to={routes.editProfile.root} className="btn btn-primary">
          Edit Profile
        </Link>
        <hr />
      </Fragment>
    );
  };

  renderInfoSection = () => {
    const { user } = this.props;
    const jobInfo = filter((exists) => exists, [user.jobTitle, user.organization]).join(' at ');
    const workAreas = user.workAreas.map((area) => area.name).join(', ');

    return (
      <div className="w-100 p-3">
        <h4>Information</h4>
        {jobInfo && <div>{jobInfo}</div>}
        {user.website && (
          <a href={user.website} target="_blank">
            {user.website}
          </a>
        )}
        <div className="my-3">
          {user.workPhone && <div>{user.workPhone} (Office)</div>}
          {user.homePhone && <div>{user.homePhone} (Home)</div>}
          {user.email && <div>{user.email}</div>}
        </div>
        {workAreas && (
          <Fragment>
            <div className="my-1">Areas of Work:</div>
            <div>{workAreas}</div>
          </Fragment>
        )}
      </div>
    );
  };

  render() {
    const { collapsed } = this.props;

    return (
      <div
        className={cn(styles.sidebar, 'background-dark d-none d-md-flex py-5', {
          'col-md-2': !collapsed,
          [styles.shrink]: collapsed,
        })}
      >
        {this.renderBasicInfo()}
        {this.renderProgressSection()}
        {this.renderInfoSection()}
      </div>
    );
  }
}

Sidebar.propTypes = propTypes;

export default Sidebar;
